module.exports = function init_scroll_to_top() {

  const stt = document.querySelector('#scroll-to-top');
  if(stt) {
    stt.addEventListener('click', function() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }

}

